const carouselItems = [
  {
    id: 1,
    title: '暑期档国产影片观影指南',
    desc: '这个夏天最值得看的国产影片都在这里，从动作大片到温情剧情，91年国产影片视频为你精选暑期档必看片单，让每一天都有好片相伴。',
    tag: '特别企划',
    image: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20atmosphere%20with%20golden%20sunlight%20streaming%20through%20theater%20windows%2C%20red%20velvet%20seats%2C%20film%20projector%20beam%2C%20warm%20nostalgic%20movie%20palace%20aesthetic%2C%20cinematic%20wide%20shot%2C%20rich%20amber%20and%20crimson%20tones%2C%20professional%20architectural%20photography&width=1200&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '高分国产剧情片 — 值得反复品味',
    desc: '盘点91免费在线视频平台上评分最高的国产剧情片，每一部都是经得起时间考验的口碑佳作，带你感受中国电影的独特魅力。',
    tag: '精选合集',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20drama%20film%20scene%20with%20soft%20natural%20light%20through%20traditional%20window%20lattice%2C%20actor%20in%20contemplative%20pose%2C%20warm%20earthy%20tones%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20emotional%20atmosphere%2C%20award-winning%20cinematography&width=1200&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '经典老片修复 — 那些年我们追过的电影',
    desc: '91麻豆免费视频网站全新上线的经典老片修复专区，用高清画质重温国产影片的黄金年代，每一帧都是满满的回忆与感动。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20cinema%20display%20with%20old%20film%20posters%20on%20weathered%20brick%20wall%2C%20antique%20film%20projector%20with%20warm%20glow%2C%20dust%20particles%20in%20light%20beams%2C%20nostalgic%20sepia%20and%20golden%20tones%2C%20retro%20movie%20theater%20atmosphere%2C%20artistic%20composition&width=1200&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '91福利在线视频 — 每日独家内容精选',
    desc: '每天更新的91福利在线视频专区汇集全网热门国产影片，涵盖最新上映与独家首播内容，让你的观影选择永远充满新鲜感。',
    tag: '每日精选',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20cinema%20setup%20with%20large%20screen%20displaying%20vibrant%20cinematic%20scene%2C%20cozy%20dark%20room%20with%20ambient%20LED%20strip%20lighting%20in%20warm%20red%20tones%2C%20popcorn%20and%20drinks%2C%20comfortable%20viewing%20environment%2C%20professional%20interior%20photography%2C%20cinematic%20mood&width=1200&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="section-scroll py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">精彩专题</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">焦点专题</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            91年国产影片视频为你精心策划的四大专题栏目
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="group relative block rounded-2xl overflow-hidden bg-gray-900 cursor-pointer"
            >
              <div className="aspect-[2.4/1] md:aspect-[2.2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    const p = t.parentElement?.parentElement;
                    if (p) {
                      p.classList.add('bg-gradient-to-br', 'from-red-900', 'to-gray-900', 'flex', 'items-center', 'justify-center');
                      p.innerHTML = `<div class="text-center p-8"><p class="text-white/60 text-lg font-bold mb-2">${item.title}</p><p class="text-white/40 text-sm">${item.tag}</p></div>`;
                    }
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-md bg-red-600 text-white text-xs font-semibold mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mb-1">{item.title}</h3>
                <p className="text-sm text-gray-300 leading-relaxed line-clamp-2 hidden sm:block">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}